// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"85530f85","703":"abcb1e46"}[chunkId] + ".chunk.js";
};